import React from 'react'
import styled from "styled-components"

const Vertical = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justifyContent};
  width: ${props => props.width};
  height: ${props => props.height};
  align-items: ${props => props.alignItems};
`

const VerticalAlign = ({content = "", width = "100%", height = "100%", alignItems = "center", justifyContent = "space-between", children}) => {
    return <Vertical width={width} alignItems={alignItems}
                     justifyContent={justifyContent} height={height}>{content}{children}</Vertical>
}
export default VerticalAlign
